var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"tw:flex tw:items-center tw:gap-2 tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:no-underline tw:transition-colors",class:_vm.active
        ? 'tw:text-brand-primary tw:font-semibold tw:bg-brand-primary/10'
        : 'tw:text-slate-400 tw:hover:text-slate-200 tw:hover:bg-slate-800/40',attrs:{"to":_vm.to}},[_c('i',{staticClass:"fa fa-hashtag tw:shrink-0"}),_c('span',{staticClass:"tw:truncate"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }